/*
 * @Author: yaoqiang
 * @Date: 2024-03-21 14:00:49
 * @LastEditors: yaoqiang
 * @LastEditTime: 2024-03-21 14:00:49
 * @Description:
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	data: {
		getDepartment: {
			url: `${config.MAIN_URL}/api/v1/department/list`,
			name: "飞行任务获取部门列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},

		},
		revocation: {
			url: `${config.MAIN_URL}/api/v1/cooperationTask/revocation`,
			name: "飞行任务获取部门列表",
			get: async function (params) {
				return await http.get(this.url + params);
			},

		},
		taskUsers: {
			url: `${config.MAIN_URL}/api/v1/taskUsers`,
			name: "查询聊天室在线人员信息",
			get: async function (params) {
				return await http.get(this.url + params);
			},

		},
		userBySource: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/userBySource`,
			name: "根据用户端查询用户",
			get: async function (params) {
				return await http.get(this.url + params);
			},

		},
		getDicList: {
			url: `${config.MAIN_URL}/api/v1/flyTask/getDicList`,
			name: "飞行任务获取下拉列表",
			get: async function () {
				return await http.get(this.url);
			},
		},
		cooperationTask: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask`,
			name: "概览页进行中的任务",
			get: async function () {
				return await http.get(this.url);
			},
		},
		getAircraftNo: {
			url: `${config.MAIN_URL}/maintenance/breakdownManage/getAircraftNo`,
			name: "机号下拉列表",
			get: async function () {
				return await http.get(this.url);
			},
		},
		statusxt: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/status`,
			name: "获取任务状态",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
		team: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/user/team`,
			name: "查询小组人员",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
		checkOrZh: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/user/checkOrZh`,
			name: "查询指挥员或待审核人员",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
		modify: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/team/modify`,
			name: "修改小组人员",
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		pass: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/pass`,
			name: "设置密码",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		applyToJoin: {
			url: `${config.MAIN_URL}/api/v1/cooperationTask/applyToJoin`,
			name: "协同标绘任务加入申请",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		passinput: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/pass/input`,
			name: "输入密码查看",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		zhmodify: {
			url: `${config.MAIN_URL}/api/v2/cooperationTask/zh/modify`,
			name: "修改指挥人员",
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		list: {
			url: `${config.MAIN_URL}/api/v1/flyTask/list/pc`,
			name: "查询飞行任务列表",
			get: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/flyTask/save`,
			name: "保存飞行任务",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		update: {
			url: `${config.MAIN_URL}/api/v1/flyTask/update`,
			name: "修改飞行任务",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/flyTask/delete`,
			name: '删除飞行任务',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
		get: {
			url: `${config.MAIN_URL}/api/v1/flyTask/get`,
			name: "回显飞行任务",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
		setStatus: {
			url: `${config.MAIN_URL}/api/v1/flyTask/setStatus`,
			name: "回显飞行任务",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},

	checkdata: {
		queryByPage: {
			url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/queryByPage`,
			name: "航务登机检查单-分页查询",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	}
};
